<template>
  <div>
    <div class="has-background-white" style="padding: 0.5em;">
      <div class="list-header">
        <p class="is-size-4 has-text-grey-dark">
          ランダムランキング
          <b-icon icon="info-circle" type="is-info" size="is-small" @click.native="isActive = !isActive"/>
        </p>
        <b-notification :active="isActive" has-icon type="is-info"
                        aria-close-label="Close notification">
          過去のデイリーランキングからランダムにツイートを表示しています。1時間に1回表示されるツイートを更新しています。
        </b-notification>
        <div style="margin-top:1em;">
          <b-pagination
            :total="ranking_tweets.length"
            :current.sync="current_page_num"
            :range-before="2"
            :range-after="1"
            :order="'is-centered'"
            :size="''"
            :rounded="true"
            :per-page="one_page_tweet_num"
            :icon-prev="'chevron-left'"
            :icon-next="'chevron-right'"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            type="is-danger">
          </b-pagination>
        </div>
      </div>
    </div>
    <div  class="columns is-gapless is-multiline is-desktop">
      <div v-for="tweet in show_tweets" :key="tweet.id" class="column is-4-desktop">
        <TweetBox :tweet_info="tweet" @tweet-regist="changeRegistState(tweet.id)"/>
      </div>
    </div>
    <b-pagination
        class="list-header"
        :total="ranking_tweets.length"
        :current.sync="current_page_num"
        :range-before="2"
        :range-after="1"
        :order="'is-centered'"
        :size="''"
        :rounded="true"
        :per-page="one_page_tweet_num"
        :icon-prev="'chevron-left'"
        :icon-next="'chevron-right'"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        type="is-danger">
    </b-pagination>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
import firebase from '@/firebase'
import TweetBox from '@/components/TweetBox.vue'

export default {
  title: "- ランダムランキング",
  components: {
    TweetBox
  },
  data() {
    return {
      ranking_tweets: [],
      current_page_num: 1,
      isLoading: false,
      isActive: false,
    }
  },
  computed: {
    page_num() {
      if(this.$route.query.page == undefined){return 1}
      return Number(this.$route.query.page)
    },
    one_page_tweet_num: () => 15,
    show_tweets() {
      if(this.ranking_tweets.length == 0 || this.ranking_tweets.length == undefined){
        return []
      }
      const start_idx = this.one_page_tweet_num*(this.page_num-1)
      const end_idx = start_idx + this.one_page_tweet_num
      return this.ranking_tweets.filter((elm, idx) => start_idx<=idx && idx<end_idx)
    },
  },
  watch:{
    current_page_num(val) {
      this.move_list_page(val)
    }
  },
  created() {
    if(this.page_num != 1){
      this.current_page_num = this.page_num
    }
    this.loadRankingDataFromStorage()
  },
  methods: {
    async loadRankingDataFromStorage() {
      let ranking_json = await firebase.getRandomRankingDataFromStorage()
      if(ranking_json.length > 0){
        ranking_json = ranking_json.map((tweet)=>{
          tweet.registeredListname = this.$store.getters.findRegistedList(tweet.id)
          return tweet          
        })
        this.ranking_tweets = ranking_json
      }
      else{
        this.ranking_tweets = []
      }
    },
    move_list_page(move_page) {
      if(this.ranking_tweets.length <= this.one_page_tweet_num*(move_page-1)) return
      window.scrollTo({top: 100})
      this.$router.push({path:`/randomranking`, query: { page: move_page } }).catch(()=>{})
    },
    changeRegistState(tweet_id) {
      for(let idx in this.ranking_tweets){
        if(this.ranking_tweets[idx].id == tweet_id){
          this.ranking_tweets[idx].registeredListname = this.$store.getters.findRegistedList(tweet_id)
          return
        }
      }
    },
  },
}
</script>

<style>
.list-header {
  max-width: 40em;
  margin: 0 auto;
}
</style>